module.exports = __webpack_public_path__ + "static/media/send.f18e7b40.svg";